<template>
  <div
    class="app-select-number"
    :class="{ 'is-focus': isFocus }"
  >
    <select
      ref="select"
      class="app-select-number__select"
      :style="disabled ? { 'padding-left': `${paddingLeft}rem`, 'color': '#dcdee0' } : { 'padding-left': `${paddingLeft}rem` }"
      :value="value"
      @focus="isFocus = true"
      @blur="isFocus = false"
      @input="inputed"
      :disabled="disabled"
    >
      <option
        v-for="(number) in numbers"
        :key="`app-select-number-${number}`"
        :value="number"
        class="app-select-number__option"
      >{{ `${number}${label}` }}</option>
    </select>
    <div
      class="app-select-number__icon"
      :class="{ 'is-focus': isFocus }"
      v-if="!disabled"
    >
      <img
        src="@/assets/icon/icon_select_arrow_black.svg"
        alt=""
        class="app-select-number__icon__image"
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [Number, String],
      required: false,
      default: 1
    },
    // 選択数（optionタグの数）
    numbers: {
      type: Number,
      required: true,
      default: 0
    },
    // 表示する助数詞
    label: {
      type: String,
      required: false,
      default: ''
    },
    // 表示文言の左側に付与するpadding（単位: rem）
    paddingLeft: {
      type: Number,
      required: false,
      default: 0.5
    },
    // グレーアウト表現
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data() {
    return {
      isFocus: false, // selectタグがfocusされているか
    }
  },
  methods: {
    /**
     * selectに変更があったら都度valueをemitする
     */
    inputed(e) {
      this.$emit('inputed', e.target.value)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixins.scss';
@import '@/assets/scss/variables.scss';

.app-select-number {
  align-items: center;
  border-radius: .25rem;
  display: flex;
  height: 100%;
  position: relative;
  width: 100%;

  &.is-focus {
    outline: 2px solid $black;
    outline-offset: -2px;
  }

  &__select {
    appearance: none;
    background-color: transparent;
    border-radius: .25rem;
    cursor: pointer;
    display: block;
    height: 100%;
    width: 100%;

    @include hover {
      @include focusStyle;
    }

    @include focus {
      outline: none;
    }
  }

  &__option {
    background-color: transparent;
    text-align: left;
  }

  &__icon {
    height: .75rem;
    pointer-events: none;
    position: absolute;
    right: .5rem;
    top: calc(50% - .375rem);
    transition: transform .2s;
    width: .75rem;

    &.is-focus {
      transform: rotateZ(180deg);
    }

    &__image {
      display: block;
      width: 100%;
    }
  }
}
</style>